__turbopack_context__.v({
  "align-bottom": "styles-module-scss-module__hfNrfW__align-bottom",
  "align-center": "styles-module-scss-module__hfNrfW__align-center",
  "align-top": "styles-module-scss-module__hfNrfW__align-top",
  "imageContainer": "styles-module-scss-module__hfNrfW__imageContainer",
  "promoCard": "styles-module-scss-module__hfNrfW__promoCard",
});
